var o={shadowBox:"shadowBox-module_shadowBox__tz5FG",animateOnHoverMobile:"shadowBox-module_animateOnHoverMobile__mu7X1",animateOnHoverDesktop:"shadowBox-module_animateOnHoverDesktop__orSv9"};export{o as default};
